import React, { useState } from "react";
import { Instagram, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Namaste.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <footer
      className="mt-32 pt-24 pb-12 relative"
      style={{ background: "var(--kaiya-text)", color: "var(--kaiya-bg)" }}
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/assets/kaiya_logo.png" alt="KaiyaYoga" className="h-20 mb-6" style={{ filter: "brightness(0) saturate(100%) invert(65%) sepia(48%) saturate(415%) hue-rotate(324deg) brightness(89%) contrast(90%)" }} />
          <p className="opacity-90 max-w-md leading-relaxed mb-8 text-white">
            Through art and intention, we create spaces that inspire creativity, possibility, and growth.
          </p>
          <form onSubmit={subscribe} className="flex items-center gap-2 max-w-sm">
            <input
              data-testid="footer-newsletter-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-transparent border-b border-white/40 py-3 outline-none placeholder:text-white/40 focus:border-white"
            />
            <button
              data-testid="footer-newsletter-submit"
              type="submit"
              disabled={loading}
              className="p-3 hover:opacity-60 transition"
              aria-label="Subscribe"
            >
              <ArrowRight size={20} />
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4" style={{ color: "rgba(249,246,240,0.5)" }}>Shop</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/products" className="hover:opacity-60">All towels</a></li>
            <li><a href="/product/sure" className="hover:opacity-60">Sure</a></li>
            <li><a href="/product/april" className="hover:opacity-60">April</a></li>
            <li><a href="/product/occult" className="hover:opacity-60">Occult</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="label-eyebrow mb-4" style={{ color: "rgba(249,246,240,0.5)" }}>Studio</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/artist" className="hover:opacity-60">The Artist</a></li>
            <li><a href="/about" className="hover:opacity-60">Manifesto</a></li>
            <li><a href="mailto:hello@kaiyayoga.com" className="hover:opacity-60">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="label-eyebrow mb-4" style={{ color: "rgba(249,246,240,0.5)" }}>Follow</div>
          <a
            href={process.env.REACT_APP_INSTAGRAM_URL}
            target="_blank" rel="noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-3 hover:opacity-60"
          >
            <Instagram size={20} />
            <span>@{process.env.REACT_APP_INSTAGRAM_HANDLE}</span>
          </a>
        </div>
      </div>

      {/* Brand mantra — matches the /about manifesto: two lines, "let's grow." in coral */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-16 md:mt-20 mb-6 text-center" data-testid="footer-mantra">
        <div className="font-serif-display text-2xl md:text-4xl leading-[0.95]">
          let go.<br />
          <span style={{ color: "var(--kaiya-primary)" }}>let&apos;s grow.</span>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs opacity-50">
        <div>© {new Date().getFullYear()} KaiyaYoga. Designed in Canada.</div>
        <div>kaiyayoga.com</div>
      </div>
    </footer>
  );
}
